<app-banner [banner]="offlineAirlinePage.banner"></app-banner>
<div class="container mt-5 mb-5">
<table class="offline-airline-profile-table"> 
<app-offline-airline-profile-table-section [tableSections]="offlineAirlinePage.tableSections"></app-offline-airline-profile-table-section> 


    
      